
import {
  CATEGORY_DESCRIPTIONS,
  CATEGORY_LABELS,
  OrphanExecuteResult,
  OrphanPreview,
  REASON_LABELS
} from "@/api/orphanSubcollections";
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: { MBaseModal, MButton },
  props: {
    preview: { type: Object, required: true },
    running: { type: Boolean, default: false },
    result: { type: Object, default: null }
  },
  emits: ["close", "execute"]
})
export default class OrphanDeletionModal extends Vue {
  preview!: OrphanPreview;
  running!: boolean;
  result!: OrphanExecuteResult | null;

  get categoryLabel(): string {
    return CATEGORY_LABELS[this.preview.category];
  }
  get categoryDescription(): string {
    return CATEGORY_DESCRIPTIONS[this.preview.category];
  }
  get categoryBadgeClass(): string {
    return this.preview.category === "moved_leftover"
      ? "bg-green-100 text-green-700"
      : this.preview.category === "ownerless"
      ? "bg-yellow-100 text-yellow-700"
      : "bg-red-100 text-red-700";
  }
  get canExecute(): boolean {
    return !this.running;
  }
  // 取り消せない削除なので、実行の前に、件数を示して、もう一度確認する
  confirmAndExecute() {
    if (!this.canExecute) return;
    const ok = window.confirm(
      `${this.preview.docCount} 件の文書を削除します。この操作は取り消せません。よろしいですか？`
    );
    if (ok) this.$emit("execute", this.preview.docCount);
  }
  get resultClass(): string {
    return this.result?.executed
      ? "bg-green-50 border border-green-300 text-green-700"
      : "bg-red-50 border border-red-300 text-red-700";
  }
  get resultMessage(): string {
    if (!this.result) return "";
    return this.result.executed
      ? `${this.result.deletedCount} 件の文書を削除しました。`
      : `削除しませんでした: ${this.reasonLabel(this.result.reason)}`;
  }
  reasonLabel(reason?: string): string {
    return (reason && REASON_LABELS[reason]) || reason || "理由が不明です";
  }
}
